import { render } from "./DayRegistrationTab.vue?vue&type=template&id=756e832e"
import script from "./DayRegistrationTab.vue?vue&type=script&lang=js"
export * from "./DayRegistrationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__